import { render, staticRenderFns } from "./VLegacyFileManger.vue?vue&type=template&id=0355d6fc&"
import script from "./VLegacyFileManger.vue?vue&type=script&lang=js&"
export * from "./VLegacyFileManger.vue?vue&type=script&lang=js&"
import style0 from "./VLegacyFileManger.vue?vue&type=style&index=0&id=0355d6fc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports